/**
 * Validates if a string is a valid UUID format.
 * 
 * @param str - The string to validate
 * @returns true if the string is a valid UUID, false otherwise
 */
export function isValidUUID(str: string): boolean {
  if (!str || typeof str !== 'string') {
    return false;
  }
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
}
